import { motion } from "motion/react";

import { NoData } from "@/components/NoData/NoData";
import { FullSizeLoader } from "@/design-system/FullSizeLoader";

function LoadingState(): React.ReactNode {
  return (
    <motion.div
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: "linear" }}
      className="absolute inset-0 z-raised bg-background-default"
    >
      <FullSizeLoader noDelay />
    </motion.div>
  );
}

function EmptyState(): React.ReactNode {
  return (
    <motion.div
      className="absolute inset-0 z-raised flex items-center justify-center bg-background-default p-space-md"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, ease: "linear" }}
    >
      <NoData />
    </motion.div>
  );
}

type ErrorStateProps = {
  error: Error | null;
  onReload?: () => void;
};

function ErrorState({ error, onReload }: ErrorStateProps): React.ReactNode {
  return (
    <motion.div
      className="absolute inset-0 z-raised flex items-center justify-center bg-background-default p-space-md"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, ease: "linear" }}
    >
      <NoData {...{ error, onReload }} />
    </motion.div>
  );
}

export const AnalyticsWidgetStates = {
  Loading: LoadingState,
  Empty: EmptyState,
  Error: ErrorState,
};
